import { z } from 'zod';

export const reportsSchema = z.object({
  dacId: z.number().min(1, { message: 'Veuillez sélectionner un DAC' }),
  dateReport: z.date({
    required_error: 'Veuillez sélectionner une date',
    invalid_type_error: "Format de date invalide",
  }),
  motifReport: z.string().min(1, { message: 'Veuillez entrer un motif' }),
  sourceDemande: z.string().min(1, { message: 'Veuillez sélectionner une source' }),
});

export type ReportsValidation = z.infer<typeof reportsSchema>;
